import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
  `,
  stickyDay: css`
    position: -webkit-sticky;
    position: sticky;
    align-self: flex-start;
  `,
  dayContainer: css`
    display: flex;
    flex-direction: column;
    width: 35px;
    text-align: center;
  `,
  weekday: css`
    text-transform: uppercase;
    font-size: 13px;
    color: ${colors.slate};
  `,
  day: css`
    color: ${colors.slate};
    font-size: 19px;
  `,
  cards: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 16px;
    margin-bottom: 16px;
  `,
};

export default styles;
